import {
	EventDispatcher,
	Matrix4,
	Plane,
	PlaneHelper,
	Raycaster,
	Vector2,
	Vector3
} from 'three';
import { ThreeView } from '../View3dWebCad';

const _plane = new Plane();
const _raycaster = new Raycaster();

const _pointer = new Vector2();
const _offset = new Vector3();
const _intersection = new Vector3();
const _worldPosition = new Vector3();
const _inverseMatrix = new Matrix4();
const _pointStart = new Vector3();
const _positionStart = new Vector3();

let _ClientRect = null;
let _height = 0;
let _width = 0;

class IconDragControls extends EventDispatcher {

	constructor( _objects, _camera, _domElement ) {

		super();

		_domElement.style.touchAction = 'none'; // disable touch scroll

		let _selected = null, _hovered = null;

		const _intersections = [];

		//

		const scope = this;

		function activate() {

			_domElement.addEventListener( 'pointermove', onPointerMove );
			_domElement.addEventListener( 'pointerdown', onPointerDown );
			_domElement.addEventListener( 'pointerup', onPointerCancel );
			_domElement.addEventListener( 'pointerleave', onPointerCancel );

		}

		function deactivate() {

			_domElement.removeEventListener( 'pointermove', onPointerMove );
			_domElement.removeEventListener( 'pointerdown', onPointerDown );
			_domElement.removeEventListener( 'pointerup', onPointerCancel );
			_domElement.removeEventListener( 'pointerleave', onPointerCancel );

			_domElement.style.cursor = '';

		}

		function dispose() {

			deactivate();

		}

		function getObjects() {

			return _objects;

		}

		function getRaycaster() {

			return _raycaster;

		}

		function onPointerMove( event ) {

			if ( scope.enabled === false ) return;

			updatePointer( event );

			_raycaster.setFromCamera( _pointer, _camera );

			if ( _selected ) {

				if ( _raycaster.ray.intersectPlane( _plane, _intersection ) ) {

					_offset.copy(_intersection).sub(_pointStart);
					_selected.position.copy(new Vector3(_positionStart.x + _offset.x, _positionStart.y, _positionStart.z + _offset.z));
					_selected.position.applyMatrix4( _inverseMatrix );

				}

				scope.dispatchEvent( { type: 'drag', object: _selected } );

				return;

			}

		}

		// 対象オブジェクトを取得
		function getTarget( object ) {
			const index = _objects.findIndex((obj) => obj.uuid == object.uuid);
			if (index <= -1)  return getTarget(object.parent);
			return _objects[index];
		}

		function onPointerDown( event ) {

			if ( scope.enabled === false ) return;

			updatePointer( event );

			_raycaster.setFromCamera( _pointer, _camera );

			if (event.clientX > _ClientRect.x && event.clientY > _ClientRect.y && 
				_ClientRect.x + _width > event.clientX && _ClientRect.y + _height > event.clientY) {
				
				_selected = getTarget(_objects[0]);

				const direction = _camera.getWorldDirection(new Vector3());
				const e = _camera.matrixWorld.elements;
				// const down = new Vector3(-e[4], -e[5], -e[6]).normalize();
				const down = ThreeView.get().ItemDragManager.isCeilingItem() ? new Vector3(e[4], e[5], e[6]).normalize() : new Vector3(-e[4], -e[5], -e[6]).normalize();	
				_plane.normal = direction.add(down).normalize();
				_plane.setFromNormalAndCoplanarPoint(  _plane.normal, _worldPosition.setFromMatrixPosition( _selected.matrixWorld ) );

				if ( _raycaster.ray.intersectPlane( _plane, _intersection ) ) {
					
					_inverseMatrix.copy( _selected.parent.matrixWorld ).invert();
					_positionStart.copy(_worldPosition.setFromMatrixPosition( _selected.matrixWorld ));
					_pointStart.copy(_intersection);

				}

				_domElement.style.cursor = 'move';

				scope.dispatchEvent( { type: 'dragstart', object: _selected } );

			}


		}

		function onPointerCancel() {

			if ( scope.enabled === false ) return;

			if ( _selected ) {

				scope.dispatchEvent( { type: 'dragend', object: _selected } );

				_selected = null;

			}

			_domElement.style.cursor = _hovered ? 'pointer' : 'auto';

		}

		function updatePointer( event ) {

			const rect = _domElement.getBoundingClientRect();

			_pointer.x = ( event.clientX - rect.left ) / rect.width * 2 - 1;
			_pointer.y = - ( event.clientY - rect.top ) / rect.height * 2 + 1;

		}
		
		
		// picker位置設定
		function setPicker(ClientRect, height, width) {
			_ClientRect = ClientRect; 
			_height = height; 
			_width = width; 

			return this;
		}

		activate();

		// API

		this.enabled = true;
		this.transformGroup = false;

		this.activate = activate;
		this.deactivate = deactivate;
		this.dispose = dispose;
		this.getObjects = getObjects;
		this.getRaycaster = getRaycaster;

		this.setPicker = setPicker;

	}

}

export { IconDragControls };
